import { Component, OnInit, ElementRef } from '@angular/core';
import { AdminLayerDownloadComponent } from '../admin-layer-download/admin-layer-download.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from '@angular/router';
import {ShareMapService} from '../share-map.service';
import {Globals} from '../../globals';
@Component({
  selector: 'app-shared-admin-layer',
  templateUrl: './shared-admin-layer.component.html',
  styleUrls: ['./shared-admin-layer.component.css']
})
export class SharedAdminLayerComponent implements OnInit {
  map1: any;
  public mapElement: ElementRef;
  emailHide=false;
  layerId: any;
  token: any;
  _tileServerUrl;
  constructor(public dialog: MatDialog,private ShareMapService:ShareMapService,private route:ActivatedRoute,private _snackBar: MatSnackBar) {
    this._tileServerUrl = Globals.tileserver;
   }

  ngOnInit() {
    this.layerId= this.route.snapshot.paramMap.get('layerid')
    if(localStorage.currentUser)
    {
      this.token = JSON.parse(localStorage.currentUser).token
    }

  }

  adminLayerDownload(){
    if(localStorage.getItem('currentUser')){
      this.emailHide = true

    }
    var data1 = {
      "emailHide":this.emailHide ,
      "layerid":this.layerId,
      "token":this.token
    }
    const dialogRef = this.dialog.open(AdminLayerDownloadComponent, {
      width: '50%',
      data :data1
    }).afterClosed().subscribe( data => {
      if(data){
        this._snackBar.open("An Email with download link has been Sent Successfully.", "OK! Thank you", {
        });
      }
    })
  }

}
